var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0544 22.1128L53.0544 9.95819L40.8997 9.95819L40.8997 13.61L46.866 13.61L33.4263 27.2489L36.0274 29.812L49.4026 16.2386V22.1128H53.0544Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2499 15.25L15.25 15.25V47.75L47.75 47.75L47.75 21.7499L44 25.4382L44 44L19 44L19 19L37.7362 19L41.2499 15.25ZM44 21.7211L44 19L41.5546 19L45.2498 15.25L47.75 15.25L47.75 17.9156L44 21.7211Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.ba3511f6809a11611639a61db1a98091.svg";
export { ForwardRef as ReactComponent };